import { createFileRoute } from '@tanstack/react-router';

import { JadePageContent } from '~/components/products/jade/JadePageContent';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const JadePage = () => {
  return <JadePageContent />;
};

export const Route = createFileRoute('/products/jade')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: JadePage,
});

